import React from "react";
import ReactDOM from "react-dom";
import TodoList from "./TodoList";
import "./TodoList.css";

ReactDOM.render( < TodoList / > , document.getElementById("root"));